export var MboxEvents = {
    MBOX_ACTIVE_EVENT_ID: 276,
    MBOX_USED_EVENT_ID: 275,
    MBOX_RESPONSE_TYPE_EVENT_ID: 279,
    MBOX_RESPONSE_FEATURES_EVENT_ID: 280,
    TOTAL_MBOX_ACTIVE_EVENT_ID: 262,
    TOTAL_MBOX_USED_EVENT_ID: 266,
    GLOBAL_PARAMETER_COUNT_EVENT_ID: null,
    PAGE_PARAMETER_COUNT_EVENT_ID: null,
    MBOX_PARAMETER_COUNT_EVENT_ID: null,
    MBOX_PROFILE_PARAMETER_COUNT_EVENT_ID: null
};
export var FoocEvents = {
    FOOCMASK_TIMEOUT_EVENT_ID: 277,
    FOOCMASK_DURATION_EVENT_ID: 278
};
export var RENDER_ERROR_EVENT_ID = 281;
export var event = function(id, value, isConversion) {
    if (isConversion === void 0) isConversion = false;
    return {
        id: id,
        value: value,
        isConversion: isConversion
    };
};

//# sourceMappingURL=qmEvents.js.map